var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"green-button",class:_vm.className,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }